/* WARNING: This file is auto-generated. Do not edit directly.   */
/* To make changes, edit `lib/generators/constants_generator.rb` */
/* To regenerate, run: `rails g constants`                       */

import { ConstantsQuery } from 'queries';

import { StateEnum } from 'queries';

export const ALABAMA = 'AL';
export const ALASKA = 'AK';
export const ARIZONA = 'AZ';
export const ARKANSAS = 'AR';
export const CALIFORNIA = 'CA';
export const COLORADO = 'CO';
export const CONNECTICUT = 'CT';
export const DELAWARE = 'DE';
export const DISTRICT_OF_COLUMBIA = 'DC';
export const FLORIDA = 'FL';
export const GEORGIA = 'GA';
export const HAWAII = 'HI';
export const IDAHO = 'ID';
export const ILLINOIS = 'IL';
export const INDIANA = 'IN';
export const IOWA = 'IA';
export const KANSAS = 'KS';
export const KENTUCKY = 'KY';
export const LOUISIANA = 'LA';
export const MAINE = 'ME';
export const MARYLAND = 'MD';
export const MASSACHUSETTS = 'MA';
export const MICHIGAN = 'MI';
export const MINNESOTA = 'MN';
export const MISSISSIPPI = 'MS';
export const MISSOURI = 'MO';
export const MONTANA = 'MT';
export const NEBRASKA = 'NE';
export const NEVADA = 'NV';
export const NEW_HAMPSHIRE = 'NH';
export const NEW_JERSEY = 'NJ';
export const NEW_MEXICO = 'NM';
export const NEW_YORK = 'NY';
export const NORTH_CAROLINA = 'NC';
export const NORTH_DAKOTA = 'ND';
export const OHIO = 'OH';
export const OKLAHOMA = 'OK';
export const OREGON = 'OR';
export const PENNSYLVANIA = 'PA';
export const PUERTO_RICO = 'PR';
export const RHODE_ISLAND = 'RI';
export const SOUTH_CAROLINA = 'SC';
export const SOUTH_DAKOTA = 'SD';
export const TENNESSEE = 'TN';
export const TEXAS = 'TX';
export const UTAH = 'UT';
export const VERMONT = 'VT';
export const VIRGINIA = 'VA';
export const WASHINGTON = 'WA';
export const WEST_VIRGINIA = 'WV';
export const WISCONSIN = 'WI';
export const WYOMING = 'WY';
export const ALBERTA = 'AB';
export const BRITISH_COLUMBIA = 'BC';
export const MANITOBA = 'MB';
export const NEW_BRUNSWICK = 'NB';
export const NEWFOUNDLAND_AND_LABRADOR = 'NL';
export const NOVA_SCOTIA = 'NS';
export const ONTARIO = 'ON';
export const PRINCE_EDWARD_ISLAND = 'PE';
export const QUEBEC = 'QC';
export const SASKATCHEWAN = 'SK';

export type StateType = ConstantsQuery['states'][number];

const STATES: StateType[] = [
  {
    abbrev: ALABAMA,
    isAmerican: true,
    name: 'Alabama',
    slug: 'alabama',
    key: StateEnum.ALABAMA
  },
  {
    abbrev: ALASKA,
    isAmerican: true,
    name: 'Alaska',
    slug: 'alaska',
    key: StateEnum.ALASKA
  },
  {
    abbrev: ARIZONA,
    isAmerican: true,
    name: 'Arizona',
    slug: 'arizona',
    key: StateEnum.ARIZONA
  },
  {
    abbrev: ARKANSAS,
    isAmerican: true,
    name: 'Arkansas',
    slug: 'arkansas',
    key: StateEnum.ARKANSAS
  },
  {
    abbrev: CALIFORNIA,
    isAmerican: true,
    name: 'California',
    slug: 'california',
    key: StateEnum.CALIFORNIA
  },
  {
    abbrev: COLORADO,
    isAmerican: true,
    name: 'Colorado',
    slug: 'colorado',
    key: StateEnum.COLORADO
  },
  {
    abbrev: CONNECTICUT,
    isAmerican: true,
    name: 'Connecticut',
    slug: 'connecticut',
    key: StateEnum.CONNECTICUT
  },
  {
    abbrev: DELAWARE,
    isAmerican: true,
    name: 'Delaware',
    slug: 'delaware',
    key: StateEnum.DELAWARE
  },
  {
    abbrev: DISTRICT_OF_COLUMBIA,
    isAmerican: true,
    name: 'Washington, D.C.',
    slug: 'washington-dc',
    key: StateEnum.DISTRICT_OF_COLUMBIA
  },
  {
    abbrev: FLORIDA,
    isAmerican: true,
    name: 'Florida',
    slug: 'florida',
    key: StateEnum.FLORIDA
  },
  {
    abbrev: GEORGIA,
    isAmerican: true,
    name: 'Georgia',
    slug: 'georgia',
    key: StateEnum.GEORGIA
  },
  {
    abbrev: HAWAII,
    isAmerican: true,
    name: 'Hawaii',
    slug: 'hawaii',
    key: StateEnum.HAWAII
  },
  {
    abbrev: IDAHO,
    isAmerican: true,
    name: 'Idaho',
    slug: 'idaho',
    key: StateEnum.IDAHO
  },
  {
    abbrev: ILLINOIS,
    isAmerican: true,
    name: 'Illinois',
    slug: 'illinois',
    key: StateEnum.ILLINOIS
  },
  {
    abbrev: INDIANA,
    isAmerican: true,
    name: 'Indiana',
    slug: 'indiana',
    key: StateEnum.INDIANA
  },
  {
    abbrev: IOWA,
    isAmerican: true,
    name: 'Iowa',
    slug: 'iowa',
    key: StateEnum.IOWA
  },
  {
    abbrev: KANSAS,
    isAmerican: true,
    name: 'Kansas',
    slug: 'kansas',
    key: StateEnum.KANSAS
  },
  {
    abbrev: KENTUCKY,
    isAmerican: true,
    name: 'Kentucky',
    slug: 'kentucky',
    key: StateEnum.KENTUCKY
  },
  {
    abbrev: LOUISIANA,
    isAmerican: true,
    name: 'Louisiana',
    slug: 'louisiana',
    key: StateEnum.LOUISIANA
  },
  {
    abbrev: MAINE,
    isAmerican: true,
    name: 'Maine',
    slug: 'maine',
    key: StateEnum.MAINE
  },
  {
    abbrev: MARYLAND,
    isAmerican: true,
    name: 'Maryland',
    slug: 'maryland',
    key: StateEnum.MARYLAND
  },
  {
    abbrev: MASSACHUSETTS,
    isAmerican: true,
    name: 'Massachusetts',
    slug: 'massachusetts',
    key: StateEnum.MASSACHUSETTS
  },
  {
    abbrev: MICHIGAN,
    isAmerican: true,
    name: 'Michigan',
    slug: 'michigan',
    key: StateEnum.MICHIGAN
  },
  {
    abbrev: MINNESOTA,
    isAmerican: true,
    name: 'Minnesota',
    slug: 'minnesota',
    key: StateEnum.MINNESOTA
  },
  {
    abbrev: MISSISSIPPI,
    isAmerican: true,
    name: 'Mississippi',
    slug: 'mississippi',
    key: StateEnum.MISSISSIPPI
  },
  {
    abbrev: MISSOURI,
    isAmerican: true,
    name: 'Missouri',
    slug: 'missouri',
    key: StateEnum.MISSOURI
  },
  {
    abbrev: MONTANA,
    isAmerican: true,
    name: 'Montana',
    slug: 'montana',
    key: StateEnum.MONTANA
  },
  {
    abbrev: NEBRASKA,
    isAmerican: true,
    name: 'Nebraska',
    slug: 'nebraska',
    key: StateEnum.NEBRASKA
  },
  {
    abbrev: NEVADA,
    isAmerican: true,
    name: 'Nevada',
    slug: 'nevada',
    key: StateEnum.NEVADA
  },
  {
    abbrev: NEW_HAMPSHIRE,
    isAmerican: true,
    name: 'New Hampshire',
    slug: 'new-hampshire',
    key: StateEnum.NEW_HAMPSHIRE
  },
  {
    abbrev: NEW_JERSEY,
    isAmerican: true,
    name: 'New Jersey',
    slug: 'new-jersey',
    key: StateEnum.NEW_JERSEY
  },
  {
    abbrev: NEW_MEXICO,
    isAmerican: true,
    name: 'New Mexico',
    slug: 'new-mexico',
    key: StateEnum.NEW_MEXICO
  },
  {
    abbrev: NEW_YORK,
    isAmerican: true,
    name: 'New York',
    slug: 'new-york',
    key: StateEnum.NEW_YORK
  },
  {
    abbrev: NORTH_CAROLINA,
    isAmerican: true,
    name: 'North Carolina',
    slug: 'north-carolina',
    key: StateEnum.NORTH_CAROLINA
  },
  {
    abbrev: NORTH_DAKOTA,
    isAmerican: true,
    name: 'North Dakota',
    slug: 'north-dakota',
    key: StateEnum.NORTH_DAKOTA
  },
  {
    abbrev: OHIO,
    isAmerican: true,
    name: 'Ohio',
    slug: 'ohio',
    key: StateEnum.OHIO
  },
  {
    abbrev: OKLAHOMA,
    isAmerican: true,
    name: 'Oklahoma',
    slug: 'oklahoma',
    key: StateEnum.OKLAHOMA
  },
  {
    abbrev: OREGON,
    isAmerican: true,
    name: 'Oregon',
    slug: 'oregon',
    key: StateEnum.OREGON
  },
  {
    abbrev: PENNSYLVANIA,
    isAmerican: true,
    name: 'Pennsylvania',
    slug: 'pennsylvania',
    key: StateEnum.PENNSYLVANIA
  },
  {
    abbrev: PUERTO_RICO,
    isAmerican: false,
    name: 'Puerto Rico',
    slug: 'puerto-rico',
    key: StateEnum.PUERTO_RICO
  },
  {
    abbrev: RHODE_ISLAND,
    isAmerican: true,
    name: 'Rhode Island',
    slug: 'rhode-island',
    key: StateEnum.RHODE_ISLAND
  },
  {
    abbrev: SOUTH_CAROLINA,
    isAmerican: true,
    name: 'South Carolina',
    slug: 'south-carolina',
    key: StateEnum.SOUTH_CAROLINA
  },
  {
    abbrev: SOUTH_DAKOTA,
    isAmerican: true,
    name: 'South Dakota',
    slug: 'south-dakota',
    key: StateEnum.SOUTH_DAKOTA
  },
  {
    abbrev: TENNESSEE,
    isAmerican: true,
    name: 'Tennessee',
    slug: 'tennessee',
    key: StateEnum.TENNESSEE
  },
  {
    abbrev: TEXAS,
    isAmerican: true,
    name: 'Texas',
    slug: 'texas',
    key: StateEnum.TEXAS
  },
  {
    abbrev: UTAH,
    isAmerican: true,
    name: 'Utah',
    slug: 'utah',
    key: StateEnum.UTAH
  },
  {
    abbrev: VERMONT,
    isAmerican: true,
    name: 'Vermont',
    slug: 'vermont',
    key: StateEnum.VERMONT
  },
  {
    abbrev: VIRGINIA,
    isAmerican: true,
    name: 'Virginia',
    slug: 'virginia',
    key: StateEnum.VIRGINIA
  },
  {
    abbrev: WASHINGTON,
    isAmerican: true,
    name: 'Washington',
    slug: 'washington',
    key: StateEnum.WASHINGTON
  },
  {
    abbrev: WEST_VIRGINIA,
    isAmerican: true,
    name: 'West Virginia',
    slug: 'west-virginia',
    key: StateEnum.WEST_VIRGINIA
  },
  {
    abbrev: WISCONSIN,
    isAmerican: true,
    name: 'Wisconsin',
    slug: 'wisconsin',
    key: StateEnum.WISCONSIN
  },
  {
    abbrev: WYOMING,
    isAmerican: true,
    name: 'Wyoming',
    slug: 'wyoming',
    key: StateEnum.WYOMING
  },
  {
    abbrev: ALBERTA,
    isAmerican: false,
    name: 'Alberta',
    slug: 'alberta',
    key: StateEnum.ALBERTA
  },
  {
    abbrev: BRITISH_COLUMBIA,
    isAmerican: false,
    name: 'British Columbia',
    slug: 'british-columbia',
    key: StateEnum.BRITISH_COLUMBIA
  },
  {
    abbrev: MANITOBA,
    isAmerican: false,
    name: 'Manitoba',
    slug: 'manitoba',
    key: StateEnum.MANITOBA
  },
  {
    abbrev: NEW_BRUNSWICK,
    isAmerican: false,
    name: 'New Brunswick',
    slug: 'new-brunswick',
    key: StateEnum.NEW_BRUNSWICK
  },
  {
    abbrev: NEWFOUNDLAND_AND_LABRADOR,
    isAmerican: false,
    name: 'Newfoundland and Labrador',
    slug: 'newfoundland-and-labrador',
    key: StateEnum.NEWFOUNDLAND_AND_LABRADOR
  },
  {
    abbrev: NOVA_SCOTIA,
    isAmerican: false,
    name: 'Nova Scotia',
    slug: 'nova-scotia',
    key: StateEnum.NOVA_SCOTIA
  },
  {
    abbrev: ONTARIO,
    isAmerican: false,
    name: 'Ontario',
    slug: 'ontario',
    key: StateEnum.ONTARIO
  },
  {
    abbrev: PRINCE_EDWARD_ISLAND,
    isAmerican: false,
    name: 'Prince Edward Island',
    slug: 'prince-edward-island',
    key: StateEnum.PRINCE_EDWARD_ISLAND
  },
  {
    abbrev: QUEBEC,
    isAmerican: false,
    name: 'Quebec',
    slug: 'quebec',
    key: StateEnum.QUEBEC
  },
  {
    abbrev: SASKATCHEWAN,
    isAmerican: false,
    name: 'Saskatchewan',
    slug: 'saskatchewan',
    key: StateEnum.SASKATCHEWAN
  }
];

export default STATES;
